module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n\n\n\n<form>\n    <!-- Basic Section -->\n    <div class="m-modal-section" >\n\n        <div class="m-modal-subsection" >\n            <div class="m-modal-subsection__title">Edit register</div>    \n            <div class="m-modal-column">\n            		';
 if (getRegisterValueType() == 'picklist') { 
__p+='\n                        <select class="form-control" name="register_value">\n                            ';
 _.each(getRegisterPicklistOptions(), function(value, key){ 
__p+='\n                                <option value="'+
((__t=( value.id ))==null?'':__t)+
'" ';
 if (value.id == getRegisterValue()) { 
__p+='selected';
 } 
__p+='>'+
((__t=( value.label ))==null?'':__t)+
'</option>\n                            ';
 }); 
__p+='\n                        </select>   \n                    ';
 } else { 
__p+='\n                        <div class="form-group">\n                            <label for="register_value">'+
((__t=( getRegisterLabel() ))==null?'':__t)+
'</label>\n                            <input type="input" class="form-control" name="register_value" placeholder="" value="'+
((__t=( getRegisterValue() ))==null?'':__t)+
'" >\n                        </div>\n                    ';
 } 
__p+='\n\n \n            </div>\n        </div>\n\n    \n</div>\n</form>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/devices/register/templates/body.html
// module id = 443
// module chunks = 0